var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.000002,16 H 208 c 17.728,0 32,14.272 32,32 v 160 c 0,17.728 -14.272,32 -32,32 H 48.000002 c -17.728,0 -32,-14.272 -32,-32 V 48 c 0,-17.728 14.272,-32 32,-32 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.000006,64.000001 H 79.999993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.999996,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.00001,64.000353 79.99997,-3.52e-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 191.99998,128 H 176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 144,159.99997 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16 16,16 0 0 1 16,16 z",
    transform: "matrix(0 1 1 0 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143.99998,128.00035 64.000006,128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.000006,192.00001 H 79.999993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 208,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.00001,192.00036 79.99997,-3.5e-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e2abcfc3262d3b76512d369a27ee196a.svg";
export { ForwardRef as ReactComponent };